import { HandballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const TimeoutPopup = new PopupBuilder('Timeout', {
  incident_id: HandballIncidentId.Timeout,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
